import { css } from '@emotion/core';
import { API } from "aws-amplify";
import axios from 'axios';
import 'containers/common/Detail.css';
import Moment from "moment";
import React, { Component } from "react";
import { Alert, Card, Col, Form, Modal, Row, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
// First way to import
import { PacmanLoader } from 'react-spinners';
import 'react-table/react-table.css';



const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class SaleSheetFollowUpQueueDetail extends Component {
    constructor(props) {
        super(props);


        this.state = {
            isLoading: null,
            isDeleting: null,
            cityscopeOptions: [],
            selectedCityscope: null,
            cityscope: null,
            agentids: [],
            agent_id: null,
            followupdate: null,
            cityscope: null,
            pageData: null,
            saleSheets: null,
            agent: null,
            agentContactOptions: [],
            open: true
        };



       

    }

    
    componentWillReceiveProps(prevProps) {
        
        if (prevProps.location.pathname !== this.props.location.pathname) {
            // Clean component and reload? 
            console.log("Resetting");
            window.location.reload();
        }
    }

    async loadPageData(){
        // NULL agent IDs blow up the proc, so convert them to 0s first
        const zeroedAgentIds = this.state.agentids.map(agentid => (agentid === null) ? 0 : agentid);
        await this.setState({ agentids: zeroedAgentIds });

        console.log("loadPageData");
        let pageData = []
        pageData= await this.getPageData({agentids: this.state.agentids, cityscope: this.state.cityscope, followupdate: this.state.followupdate});
        this.setState({pageData: pageData, saleSheets:  pageData[0].data.salesheet_list.sale_sheets});
        document.title = "Sale sheet follow ups: "+this.state.cityscope;
    }
  
    async componentDidMount() {
        
        this.setState({ isLoading: true }); 
        try {
            let followupdate = new Date();
            let cityscope = null;
            let agentids = [];
            if (this.props.location.state){
                if (this.props.location.state.hasOwnProperty("followupdate")){
                    followupdate = this.props.location.state.followupdate;
                }
                if (this.props.location.state.hasOwnProperty("cityscope")){
                    cityscope = this.props.location.state.cityscope;
                }
                if (this.props.location.state.hasOwnProperty("agentids")){
                    agentids = this.props.location.state.agentids;
                }
            }
            this.setState({followupdate: followupdate, cityscope: cityscope, agentids: agentids}, this.loadPageData);
                

                          
            
          
            
            

            await this.getSaleStatus();
            
            this.setState({ isLoading: false });   
        } catch (e) {
            alert(e);
        }
    }

    componentWillUnmount() {
        source.cancel();
    }

    getSaleStatus() {
        try {
            API.get("colin", `/salestatus`).then((saleStatusOptions) => {
                if (saleStatusOptions) {
                    
                    this.setState(state => ({ saleStatusOptions }));
                }
            });
        }
        catch{
            console.log("Error getting sale status");
        }
    }

    async getPageData(filter) {
        return API.post("colin", `/queues/salesheets/all`, { 'body': filter});                
    }

  
    

    handleChange = (event,salesheet) => {
        console.log(event.target.id);
        console.log(salesheet);
        
        let saleSheets = [...this.state.saleSheets];
        const index = saleSheets.findIndex( ss => salesheet.sale_sheet_id === ss.sale_sheet_id );
        saleSheets[index][event.target.id] = event.target.value;
        saleSheets[index].modified = true;
        this.setState({saleSheets});
    }

    handleCheckboxChange = ( event,salesheet) => {
        console.log(event);
        let saleSheets = [...this.state.saleSheets];
        const index = saleSheets.findIndex( ss => salesheet.sale_sheet_id === ss.sale_sheet_id );
        saleSheets[index][event.target.id] = event.target.checked;
        saleSheets[index].modified = true;
        this.setState({saleSheets});
    };

    handleDateChange = ( event,salesheet,field) => {
        console.log(event);
        let saleSheets = [...this.state.saleSheets];
        const index = saleSheets.findIndex( ss => salesheet.sale_sheet_id === ss.sale_sheet_id );
        saleSheets[index][field] = new Date(event);
        saleSheets[index].modified = true;
        this.setState({saleSheets});

    }

    handleSaleStatusChange = ( event,salesheet) => {
        console.log(event);
        let saleSheets = [...this.state.saleSheets];
        const index = saleSheets.findIndex( ss => salesheet.sale_sheet_id === ss.sale_sheet_id );
        saleSheets[index].sale_status_code = event.value;
        saleSheets[index].sale_status = event.label;
        saleSheets[index].modified = true;
        this.setState({saleSheets});   
        
    }
    handleAgentContactChange = (event, salesheet,agent, contact) =>{
        console.log(event);
        let saleSheets = [...this.state.saleSheets];
        const index = saleSheets.findIndex( ss => salesheet.sale_sheet_id === ss.sale_sheet_id );
        saleSheets[index]['entity_contact_id_'+contact+'_sale_agent_'+agent] = event.value;
        saleSheets[index]['contact_'+contact+'_sale_agent_'+agent] = event.label;
        saleSheets[index].modified = true;
        this.setState({saleSheets});   
    }

    async saveSaleSheet(saleSheet) {
        console.log("Inside save sale sheet");
        this.setState({ last_edited_by: this.props.user });
        if (this.props.match.params.id === "new" && saleSheet.sale_sheet_id === null) {
            this.setState({ created_by: this.props.user });
            return await API.post("colin", `/salesheets/new`, { body: saleSheet });
        }
        return API.put("colin", `/salesheets/${saleSheet.sale_sheet_id}`, {
            body: saleSheet
        });
    }
    
   

    validateRelatedRecord(record, set) {
        //property
        if (set === "saleSheet") {

            // secondly check that UnitSort has been specified if required

            console.log("");


        }

        if (set === "propertySaleSheets") {

            // secondly check that UnitSort has been specified if required

            if (!record.property_key) {
                return [false, "Enter a Cityscope reference."];
            }


        }

        return [true,];
    }
    

    handleSave = async (event) => {

        this.setState({ showAlert: false });
        let saleSheets = [...this.state.saleSheets];
        for (var i=0; i<saleSheets.length; i++){
            if (saleSheets[i].hasOwnProperty("modified")) {
                if (saleSheets[i].modified === true) {
                    const validation = this.validateRelatedRecord(saleSheets[i], "saleSheet");
                    console.log(validation[0]);
                    if (validation[0] === true) {
                        saleSheets[i].last_edited_by = this.props.user;
                        saleSheets[i].sale_status_date_checked = Moment(new Date()).local().format();
                        console.log(saleSheets[i]);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (saleSheets[i].hasOwnProperty("new_record")) {
                                if (saleSheets[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.saveSaleSheet(saleSheets[i]);
                            if (result.result) {
                                saleSheets[i].modified = false;
                                if (saleSheets[i].hasOwnProperty("new_record")) {
                                    if (saleSheets[i].new_record === true) {

                                        saleSheets[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    saleSheets[i].new_record = false;
                                }
                                

                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                   
                    }
                    else {
                        this.setState({ errorMessage: validation[1] });
                        this.setState({ showAlert: true });
                        return;
                    }
                }

    }
        }   
        if (saleSheets[0].hasOwnProperty("sort_order")) {
            saleSheets.sort(function (a, b) { return a.sort_order - b.sort_order });
        }

        this.setState({saleSheets});
        let pageData = [...this.state.pageData];
        pageData[0].data.salesheet_list.sale_sheets =  saleSheets;
        this.setState({pageData});
    }


    

   
    render() {
        let agent = null;
        if (this.state.agent){
            
            agent = this.state.agent;
            
        }
        return (
            
            <div className="Salesheet Queue">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {this.state.isLoading &&
                <div className="outer-div"><div className='sweet-loading inner-div' >
                    <PacmanLoader
                        css={css`
                        display: block;
                        margin: 0 auto;
                        border-color: red`}
                        sizeUnit={"px"}
                        size={20}
                        color={'#e03c31'}
                        loading={this.state.isLoading}
                    />
                </div> 
                    </div>}
               
                {this.props.isAuthenticated && !this.state.isLoading &&
                    

                    <div className="salesheets">
                    
                    { this.state.saleSheets &&
                    <div>
                        
                                {/* <Collapse in={this.state.open}> */}


                                {this.state.saleSheets.map((salesheet) => {
                                    
                                    
                                    if(salesheet){
                                    return(
                                        <div key={salesheet.sale_sheet_id}>
                                    <Card >
                                        <Card.Header>
                                            {/* <Accordion.Toggle as={Button} variant="link" eventKey={salesheet.sale_sheet_id}>                                     */}
                                            <Card.Title><Row><Col><font size="2"> {salesheet.properties[0].property_key} | {((salesheet.known_as || "").length > 0 ? salesheet.properties[0].known_as : ((salesheet.properties[0].street_num_low || "") + (salesheet.properties[0].street_num_low_suffix || "") + (salesheet.properties[0].street_num_high !== salesheet.properties[0].street_num_low ? (" - " +(salesheet.properties[0].street_num_high || "") + (salesheet.properties[0].street_num_high_suffix || "")) : "")))  + " " + salesheet.properties[0].street_name +" "+ salesheet.properties[0].suburb  +" | "+ salesheet.properties[0].building_name} </font></Col> <Col  className="text-right"><font size="2"><b>{ salesheet.sale_agent_sort }</b></font> </Col></Row></Card.Title> 
                                            {/* </Accordion.Toggle> */}
                                        </Card.Header>
                                        {/* <Accordion.Collapse eventKey={salesheet.sale_sheet_id} show> */}
                                            <Card.Body>
                                                <Row>
                                                    <Col  sm={4} md={4} lg={3}>
                                                        <Form.Group as={Row} controlId="quick_ref" >
                                                            <Form.Label className="text-right" column sm={4} md={4} lg={4}>Quick Reference</Form.Label>
                                                            <Col>
                                                                    <Form.Control
                                                                        onChange={(event)=>this.handleChange(event,salesheet)}
                                                                        value={salesheet.quick_ref}
                                                                        as="input"
                                                                        type="text"
                                                                    onBlur={this.handleSave}
                                                                    />                                                                
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="selectedSaleStatus" >
                                                        <Form.Label className="text-right" column sm={4} md={4} lg={4}>Sales Status</Form.Label>
                                                            <Col>
                                                                <Select
                                                                    value={{ value: salesheet.sale_status_code , label: salesheet.sale_status }}
                                                                    onChange={(e) => this.handleSaleStatusChange(e,salesheet)}
                                                                    options={this.state.saleStatusOptions}
                                                                    // onInputChange={this.handleInputChange}
                                                                    onBlur={this.handleSave}
                                                                />
                                                                
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="sale_status_date_checked" >
                                                            <Form.Label className="text-right" column sm={4} md={5} lg={4}>Date Last Followed Up</Form.Label>
                                                            <Col>
                                                                <DatePicker
                                                                    selected={salesheet.sale_status_date_checked? new Date( salesheet.sale_status_date_checked) : null }
                                                                    onChange={e => this.handleDateChange(e, salesheet,"sale_status_date_checked")}
                                                                    onBlur={this.handleSave}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    className="form-control"
                                                                    isClearable={true}
                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="sale_follow_up_date" >
                                                            <Form.Label className="text-right" column sm={4} md={5} lg={4}>Date Next Follow Up</Form.Label>
                                                            <Col>
                                                                <DatePicker
                                                                    selected={salesheet.sale_follow_up_date? new Date( salesheet.sale_follow_up_date) : null }
                                                                    onChange={e => this.handleDateChange(e, salesheet, "sale_follow_up_date")}
                                                                    onBlur={this.handleSave}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    className="form-control"
                                                                    isClearable={true}
                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="current" >
                                                        <Form.Label className="text-right" column sm={4} md={4} lg={4}>Current</Form.Label>
                                                            <Col >
                                                                <Form.Check
                                                                    checked={salesheet.current}
                                                                    onChange={(e) => this.handleCheckboxChange(e,salesheet)}
                                                                    label=""
                                                                    type="checkbox"
                                                                    onBlur={this.handleSave}
                                                                    name="current"                                                              
                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                        
                                                    </Col>

                                                    
                                                    
                                                 
                                                    <Col  sm={4} md={4} lg={3}>
                                                    <Form.Group as={Row} controlId="sale_agent_1" >
                                                            <Form.Label className="text-right" column sm={6} md={5} lg={4}><b>Agent 1</b></Form.Label>
                                                            <Col className="my-auto"><Row><Col>{salesheet.sale_agent_1 }</Col></Row><Row><Col><b>t:</b> {salesheet.sale_agent_1_phone }</Col></Row>
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="entity_contact_id_1_sale_agent_1" >
                                                            <Form.Label className="text-right  mt-0" column sm={4} md={5} lg={4}><b>Contact 1</b></Form.Label>
                                                            <Col><Row><Col>{salesheet.contact_1_sale_agent_1 }</Col></Row><Row><Col><b>t:</b> {salesheet.contact_1_sale_agent_1_phone }</Col></Row><Row><Col><b>e:</b> {salesheet.contact_1_sale_agent_1_email }</Col></Row> 
                                                            </Col>
                                                        </Form.Group>
                                                        <Row><Col>{" "}</Col><Col></Col></Row>
                                                        <Form.Group as={Row} controlId="entity_contact_id_2_sale_agent_1" >
                                                            <Form.Label className="text-right  mt-0" column sm={4} md={5} lg={4}><b>Contact 2</b></Form.Label>
                                                            <Col><Row><Col>{salesheet.contact_2_sale_agent_1 }</Col></Row><Row><Col><b>t:</b> {salesheet.contact_2_sale_agent_1_phone }</Col></Row><Row><Col><b>e:</b> {salesheet.contact_2_sale_agent_1_email }</Col></Row> 
                                                                
                                                            </Col>
                                                        </Form.Group>
                                                        <br/>
                                                    </Col>
                                                    <Col  sm={4} md={3} lg={3}>
                                                        <Form.Group as={Row} controlId="entity_contact_id_1_sale_agent_2" >
                                                            <Form.Label className="text-right" column sm={6} md={5} lg={4}><b>Agent 2</b></Form.Label>
                                                            <Col className="my-auto"><Row><Col>{salesheet.sale_agent_2 }</Col></Row><Row><Col><b>t:</b> {salesheet.sale_agent_2_phone }</Col></Row>
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="entity_contact_id_1_sale_agent_2" >
                                                            <Form.Label className="text-right" column sm={6} md={5} lg={4}><b>Contact 1</b></Form.Label>
                                                            <Col><Row><Col>{salesheet.contact_1_sale_agent_2 }</Col></Row><Row><Col><b>t:</b> {salesheet.contact_1_sale_agent_2_phone }</Col></Row><Row><Col><b>e:</b> {salesheet.contact_1_sale_agent_2_email }</Col></Row> 
                                                            </Col>
                                                        </Form.Group>
                                                        <Row><Col>{" "}</Col><Col></Col></Row>
                                                        <Form.Group as={Row} controlId="entity_contact_id_2_sale_agent_2" >
                                                            <Form.Label className="text-right" column sm={6} md={5} lg={4}><b>Contact 2</b></Form.Label>
                                                            <Col><Row><Col>{salesheet.contact_2_sale_agent_2 }</Col></Row><Row><Col><b>t:</b> {salesheet.contact_2_sale_agent_2_phone }</Col></Row><Row><Col><b>e:</b> {salesheet.contact_2_sale_agent_2_email }</Col></Row> 
                                                                
                                                            </Col>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col></Col>
                                                                                                             
                                                </Row>
                                                
                                                    <Form.Group as={Row} controlId="current_questions" >
                                                            
                                                            <Col>
                                                            <Form.Label ><b>Questions to ask Agent</b></Form.Label>
                                                                    <Form.Control
                                                                        onChange={(event )=>this.handleChange(event,salesheet)}
                                                                    value={(salesheet.current_questions||"")}
                                                                    as="textarea"
                                                                    rows="3"
                                                                    type="text"
                                                                    onBlur={this.handleSave}
                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                        <p id="printQuestions" >{(salesheet.current_questions||"")}</p>
                                                        <Form.Group as={Row} controlId="sales_notes" >
                                                            
                                                            <Col>
                                                            <Form.Label ><b>Sales Sheet Notes</b></Form.Label>
                                                                    <Form.Control
                                                                        onChange={(event)=>this.handleChange(event,salesheet)}
                                                                        value={(salesheet.sales_notes||"")}
                                                                        as="textarea"
                                                                        rows="6"
                                                                        type="text"
                                                                        onBlur={this.handleSave}
                                                                        
                                                                />
                                                                                                      
                                                            </Col>
                                                        </Form.Group>
                                                        <p id="printSalesNotes" >{(salesheet.sales_notes||"")}</p>

                                                     
                                                  
                                                <Row>
                                                <Col >
                                                    
                                                    {salesheet.properties.map((property) => {
                                                        return(<div key={property.property_id}>
                                                           
                                                            <b>Cityscope Owner(s):</b><br/>
                                                            {property.property_owners  && property.property_owners.map((owner) => {
                                                            return(
                                                                    <a key={owner.owner_id} target="_blank" rel="noopener noreferrer" href={`../../owners/${owner.owner_id}`}>{owner.owner_name} {" | "}</a>
                                                                    
                                                                    )
                                                            }
                                                             )
                                                            }
                                                            <br/><br/>

                                                            <Table bordered hover size="sm" responsive>
                                                                <thead>
                                                                <tr>
                                                                
                                                                    <th>Cityscope Reference</th>
                                                                    <th> Building</th>
                                                                    <th> Street Address</th>
                                                                    <th> Suburb</th>
                                                                    <th> Classification</th>
                                                                    <th> Sale Date</th>
                                                                    <th> Sale Price</th>
                                                                    
                                                                
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                <tr  >
                                                                <td><a target="_blank" rel="noopener noreferrer" href={`../../properties/${property.property_key}`}>  {property.property_key} </a></td>
                                                                <td>  {property.building_name} </td>
                                                                <td>  {(property.known_as || "").length > 0 ? property.known_as : (property.street_num_low || "") + (property.street_num_low_suffix || "") + (property.street_num_high !== property.street_num_low ? (" - " +(property.street_num_high || "") + (property.street_num_high_suffix || "")) : "") + " " + property.street_name} </td>
                                                                <td>  {property.suburb} </td>
                                                                <td>  {property.classification} </td>
                                                                <td> <a target="_blank" rel="noopener noreferrer" href={`../../sales/${property.sale_id}`}> {property.sale_date != null ? Moment(property.sale_date).local().format("DD-MM-YYYY"):""}</a></td>
                                                                <td> {property.sale_price}</td>
                                                                
                                                                </tr>
                                                                </tbody>
                                                            </Table>
                                                            <p><b>Description: </b>{property.description}</p> 
                                                            <p><b>Title details: </b>{property.title_details}</p>    
                                                            <p><b>Sales history: </b>...{property.sales_text? property.sales_text.slice(-200):""}</p>    
                                                            
                                                            </div>
                                                        )
                                                        }
                                                    )
                                                    }
                                                    
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        {/* </Accordion.Collapse> */}
                                    </Card>
                                      <div className="page-break"></div>

                                      </div>
                                    )
                            }
                                    else{
                                        return("");
                                    }
                                })
                            }
                            {/* </Collapse> */}
                          
                            
                    </div>
                   
                    }

                   
            
                    </div>


                }
            </div>
        )
        
    }
}